// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Theme, createStyles, makeStyles } from "@material-ui/core";

import { CustomerContext } from "components/App/DashboardApp";
import React from "react";
import { useContext } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleLogo: {
      height: "30px",
      display: "block",
    },
  })
);

const HeaderLogo: React.FunctionComponent<{}> = props => {
  const customContext = useContext(CustomerContext);
  const classes = useStyles();

  const { headerLogo } = customContext!.headerConfig;

  const svgLogoFile = headerLogo.svg;

  if (svgLogoFile) {
    return (
      <img
        className={classes.titleLogo}
        src={`/assets/logos/${svgLogoFile}`}
        alt={headerLogo.label}
      />
    );
  }
  if (!headerLogo.svg) {
    return <span>{headerLogo.label}</span>;
  }
  return <span />;
};

export default HeaderLogo;
